import type { Solution } from '../types/content'
import { images } from './images'

export const solutions: Solution[] = [
  {
    id: 'all-in-one',
    name: 'All-in-One Power System',
    outcome:
      'Complete containerised power for sites with no grid, or no grid you can rely on. Initial setup takes 3–4 hours.',
    image: images.delivery,
    imageAlt: 'Illustrative render of a containerised power system being trucked along an outback road',
    cta: { label: 'Explore the system', href: '#flagship' },
    flagship: true,
  },
  {
    id: 'hybrid',
    name: 'Hybrid Diesel Replacement System',
    outcome: 'Adds solar and storage alongside your existing generators, so they run less and work less hard.',
    image: images.hybrid,
    imageAlt: 'Illustrative render of a container battery system beside a diesel generator at a remote station',
    cta: { label: 'Explore with an engineer', href: '#contact' },
  },
  {
    id: 'utility',
    name: 'Utility-Scale Storage',
    outcome: 'Containerised energy storage for solar farms and grid support, sized to the project.',
    image: images.utility,
    imageAlt: 'Illustrative render of a row of energy storage containers beside a solar farm',
    cta: { label: 'Explore the brochure', href: '#resources' },
  },
]

// Values are taken from the official spec sheet. Rows show "Client to supply" until provided.
export const flagshipSpecs: { label: string; value: string | null }[] = [
  { label: 'Continuous power output', value: null },
  { label: 'Usable energy storage', value: null },
  { label: 'Storage technology', value: null },
  { label: 'Solar input capacity', value: null },
  { label: 'Container format', value: null },
  { label: 'Operating temperature range', value: null },
]

export const flagshipIncludes = [
  'Containerised power system',
  'Integration with your site and existing generation',
  'On-site commissioning',
  'Ongoing support',
]

export const flagshipDifferentiators = [
  {
    title: 'Fast to deploy',
    detail: 'Initial setup takes 3–4 hours. After that, about 30 minutes.',
  },
  {
    title: 'Simple to operate',
    detail: 'Plug-and-play once the initial setup is done.',
  },
  {
    title: 'Built for Australian conditions',
    detail: 'Durable components chosen to handle Australian conditions.',
  },
  {
    title: 'Tested in remote areas',
    detail: 'Proven in the kinds of places it’s meant to work.',
  },
]
